import { LevelsActions, fetchLevelsActionTypes } from './fetchAllLevels'
import { Level } from "../../../../models"
import { FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from '../../../../utils/request-actions-helpers/createRequestActions'

export interface LevelsState {
    levels: Level[]
    isFetching: boolean
    error?: FetchErrorInfo
}

export const initialLevelsState: LevelsState = {
    isFetching: false,
    levels: []
}

export const levelsReducer = (state: LevelsState = initialLevelsState, action: LevelsActions): LevelsState => {
    switch (action.type) {
        case fetchLevelsActionTypes.start: {
            return {
                ...state,
                isFetching: true,
            }
        }
        case fetchLevelsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Level[]>
            
            return {
                ...state,
                isFetching: false,
                levels: successAction.result
            }
        }
        case fetchLevelsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction

            return {
                isFetching: false,
                levels: state.levels,
                error: errorAction.error
            }
        }
        
        default:
            return state
    }
}